import Vue from 'vue'
import './plugins'
import App from './App'
import router from './router'
import store from './store'
import * as Sentry from "@sentry/vue"

Vue.config.productionTip = false

Sentry.init({
    Vue,
    dsn: 'https://36b0e39c9e789fda37da6b56d1e767db@o4508216622710784.ingest.de.sentry.io/4509237831729232',
    integrations: [
        Sentry.vueIntegration({
            Vue,
            tracing: true,
            tracingOptions: { trackComponents: true }
        }),
    ],
    // Performance monitoring
    tracesSampleRate: 0.1,
    // Error monitoring
    sampleRate: 1.0,
    // Will not collect any personally identifiable information
    sendDefaultPii: false,
    // Debug mode
    debug: false,
    // Before send handler
    beforeSend(event, hint) {
        const ignorePatterns = [
            "addEventListener"
        ]
        const message = hint && hint.originalException && hint.originalException.message ? hint.originalException.message : event && event.message ? event.message : ''
        if (ignorePatterns.some(pattern => message.includes(pattern))) {
            return null;
        }
        return event;
    },
    // Adjust this value to control error grouping
    maxBreadcrumbs: 50,
})
console.log('Sentry Initialized')

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
